import axiosInstance from "@/lib/axios";

export const loyaltyService = {
  getOverview: async (params = {}) => {
    const response = await axiosInstance.get("/api/v1/admin/loyalty", {
      params,
    });
    return response.data;
  },

  resetPoints: async (userId) => {
    const response = await axiosInstance.post(
      `/api/v1/admin/loyalty/${userId}/reset`
    );
    return response.data;
  },

  adjustPoints: async (userId, points, reason) => {
    const response = await axiosInstance.post(
      `/api/v1/admin/loyalty/${userId}/adjust`,
      { points, ...(reason ? { reason } : {}) }
    );
    return response.data;
  },
};
